/* EaseAir theme — vanilla replacements for the React/framer-motion behaviour. */
(function () {
  "use strict";
  var doc = document;
  var root = doc.documentElement;

  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }

  /* ---------- Scroll reveal (framer AnimatedSection) ---------- */
  function initReveal() {
    var els = $$(".reveal");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (e) { e.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-visible"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -60px 0px", threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Count-up stats ---------- */
  function initCounters() {
    var nums = $$(".stat-num");
    if (!nums.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el);
        var value = parseFloat(el.getAttribute("data-value"));
        var decimals = parseInt(el.getAttribute("data-decimals") || "0", 10);
        var sep = el.getAttribute("data-separator") === "true";
        var start = performance.now(), dur = 1600;
        function step(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var cur = value * eased, out;
          if (decimals) out = cur.toFixed(decimals).replace(".", ",");
          else if (sep) out = Math.round(cur).toLocaleString("de-DE");
          else out = Math.round(cur).toString();
          el.textContent = out;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Navbar scroll state ---------- */
  function initNav() {
    var inner = $("#site-nav-inner");
    if (inner) {
      var extra = (inner.getAttribute("data-scroll-classes") || "").split(" ").filter(Boolean);
      var onScroll = function () {
        var s = window.scrollY > 50;
        extra.forEach(function (c) { inner.classList.toggle(c, s); });
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    var toggle = $("#nav-toggle"), mob = $("#nav-mobile"), ov = $("#nav-overlay");
    var iMenu = $("#nav-icon-menu"), iClose = $("#nav-icon-close");
    function setOpen(open) {
      if (!mob) return;
      mob.classList.toggle("hidden", !open);
      if (ov) ov.classList.toggle("hidden", !open);
      if (iMenu) iMenu.classList.toggle("hidden", open);
      if (iClose) iClose.classList.toggle("hidden", !open);
      if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
      doc.body.style.overflow = open ? "hidden" : "";
    }
    on(toggle, "click", function () { setOpen(mob.classList.contains("hidden")); });
    on(ov, "click", function () { setOpen(false); });
    $$("#nav-mobile a").forEach(function (a) { on(a, "click", function () { setOpen(false); }); });
  }

  /* ---------- Dark mode + font theme ---------- */
  function initThemeToggle() {
    var darkBtn = $("#dark-btn"), moon = $("#icon-moon"), sun = $("#icon-sun");
    function syncDark() {
      var d = root.classList.contains("dark");
      if (moon) moon.classList.toggle("hidden", d);
      if (sun) sun.classList.toggle("hidden", !d);
    }
    on(darkBtn, "click", function () {
      var next = !root.classList.contains("dark");
      root.classList.toggle("dark", next);
      try { localStorage.setItem("ease-air-theme", next ? "dark" : "light"); } catch (e) {}
      syncDark();
    });
    syncDark();

    var fontBtn = $("#font-btn"), menu = $("#font-menu");
    var current = "elegant";
    try { current = localStorage.getItem("ease-air-font") || "elegant"; } catch (e) {}
    function markActive(id) {
      $$(".font-opt").forEach(function (b) {
        var active = b.getAttribute("data-font") === id;
        b.classList.toggle("bg-primary/10", active);
        b.classList.toggle("text-foreground", active);
        b.classList.toggle("text-muted-foreground", !active);
        var dot = $(".font-dot", b);
        if (dot) dot.classList.toggle("hidden", !active);
      });
    }
    markActive(current);
    on(fontBtn, "click", function () { if (menu) menu.classList.toggle("hidden"); });
    $$(".font-opt").forEach(function (b) {
      on(b, "click", function () {
        var id = b.getAttribute("data-font");
        ["elegant", "modern", "editorial"].forEach(function (f) { root.classList.remove("font-theme-" + f); });
        root.classList.add("font-theme-" + id);
        try { localStorage.setItem("ease-air-font", id); } catch (e) {}
        markActive(id);
        if (menu) menu.classList.add("hidden");
      });
    });
  }

  /* ---------- Hero sound toggle ---------- */
  function initHero() {
    var btn = $("#hero-sound");
    if (!btn) return;
    var iframe = $("#heroVimeo"), video = $("#hero-mobile-video");
    var vOn = $("#hero-sound-on"), vOff = $("#hero-sound-off");
    var muted = true;
    on(btn, "click", function () {
      muted = !muted;
      var win = iframe && iframe.contentWindow;
      if (win) {
        win.postMessage(JSON.stringify({ method: "setMuted", value: muted }), "*");
        win.postMessage(JSON.stringify({ method: "setVolume", value: muted ? 0 : 1 }), "*");
        if (!muted) win.postMessage(JSON.stringify({ method: "play" }), "*");
      }
      if (video) { video.muted = muted; if (!muted) video.play().catch(function () {}); }
      if (vOn) vOn.classList.toggle("hidden", muted);
      if (vOff) vOff.classList.toggle("hidden", !muted);
      btn.setAttribute("aria-label", muted ? "Ton aktivieren" : "Ton stummschalten");
    });
  }

 /* ---------- Product gallery ---------- */
function initGallery() {
  var stageImg = $("#pgal-img"),
      videoWrap = $("#pgal-video"),
      videoFrame = $("#pgal-iframe"),
      badge = $("#pgal-designed-badge");

  var thumbs = $$(".pgal-thumb");
  var prevBtn = $("#pgal-prev"),
    nextBtn = $("#pgal-next");
  if (!thumbs.length) return;

  var currentIndex = 0;
  var galleryStage = stageImg ? stageImg.parentElement : null;

  function select(btn) {
    currentIndex = Array.prototype.indexOf.call(thumbs, btn);

    thumbs.forEach(function (t) {
      var active = t === btn;

      t.classList.toggle("border-gold", active);
      t.classList.toggle("shadow-md", active);
      t.classList.toggle("border-transparent", !active);
      t.classList.toggle("opacity-60", !active);
    });

    /* Designed in Germany nur bei Bild 1 */
    if (badge) {
      badge.style.display = currentIndex === 0 ? "" : "none";
    }

    if (btn.getAttribute("data-type") === "video") {
      if (stageImg) stageImg.classList.add("hidden");
      if (videoWrap) videoWrap.classList.remove("hidden");

      if (videoFrame && !videoFrame.src) {
        videoFrame.src = videoFrame.getAttribute("data-src");
      }
    } else {
      if (videoWrap) videoWrap.classList.add("hidden");

      if (stageImg) {
        stageImg.classList.remove("hidden");
        stageImg.src = btn.getAttribute("data-src");
        stageImg.alt = btn.getAttribute("data-alt") || "";
      }
    }
  }

  function goTo(index) {
    if (prevBtn) {
  on(prevBtn, "click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    goTo(currentIndex - 1);
  });
}

if (nextBtn) {
  on(nextBtn, "click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    goTo(currentIndex + 1);
  });
}
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;

    select(thumbs[index]);
  }

  /* Thumbnail-Klicks */
  thumbs.forEach(function (t) {
    on(t, "click", function () {
      select(t);
    });
  });

  if (!galleryStage) return;
  /* Desktop-Pfeile */
function createGalleryArrow(direction) {
  var btn = document.createElement("button");

  btn.type = "button";
  btn.setAttribute(
    "aria-label",
    direction === "prev" ? "Vorheriges Bild" : "Nächstes Bild"
  );

  btn.textContent = direction === "prev" ? "‹" : "›";

  btn.style.position = "absolute";
  btn.style.top = "50%";
  btn.style.transform = "translateY(-50%)";
  btn.style.width = "34px";
  btn.style.height = "34px";
  btn.style.borderRadius = "9999px";
  btn.style.background = "rgba(255,255,255,0.68)";
  btn.style.border = "1px solid rgba(0,0,0,0.05)";
  btn.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
  btn.style.zIndex = "20";
  btn.style.cursor = "pointer";
  btn.style.fontSize = "20px";
  btn.style.color = "rgba(0,0,0,0.55)";
  btn.style.lineHeight = "1";
  btn.style.alignItems = "center";
  btn.style.justifyContent = "center";
  btn.style.display = window.innerWidth >= 1024 ? "flex" : "none";

  if (direction === "prev") {
    btn.style.left = "10px";
  } else {
    btn.style.right = "10px";
  }

  on(btn, "mousedown", function (e) {
    e.stopPropagation();
  });

  on(btn, "click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (direction === "prev") {
      goTo(currentIndex - 1);
    } else {
      goTo(currentIndex + 1);
    }
  });

  galleryStage.appendChild(btn);

  return btn;
}

var prevArrow = createGalleryArrow("prev");
var nextArrow = createGalleryArrow("next");

on(window, "resize", function () {
  var show = window.innerWidth >= 1024;

  prevArrow.style.display = show ? "flex" : "none";
  nextArrow.style.display = show ? "flex" : "none";
});

  /* Browser-eigenes Bildziehen deaktivieren */
  if (stageImg) {
    stageImg.setAttribute("draggable", "false");
  }

  /* MOBILE: Wischen */
  var touchStartX = 0;
  var touchStartY = 0;

  on(galleryStage, "touchstart", function (e) {
    if (!e.touches || !e.touches.length) return;

    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  });

  on(galleryStage, "touchend", function (e) {
    if (!e.changedTouches || !e.changedTouches.length) return;

    var diffX = e.changedTouches[0].clientX - touchStartX;
    var diffY = e.changedTouches[0].clientY - touchStartY;

    if (Math.abs(diffX) < 45) return;
    if (Math.abs(diffX) <= Math.abs(diffY)) return;

    if (diffX < 0) {
      goTo(currentIndex + 1);
    } else {
      goTo(currentIndex - 1);
    }
  });

  /* DESKTOP: mit gedrückter Maus ziehen */
  var mouseDown = false;
  var mouseStartX = 0;

  on(galleryStage, "mousedown", function (e) {
    if (e.target && e.target.closest("iframe")) return;

    mouseDown = true;
    mouseStartX = e.clientX;
  });

  on(galleryStage, "mouseup", function (e) {
    if (!mouseDown) return;

    var diffX = e.clientX - mouseStartX;
    mouseDown = false;

    if (Math.abs(diffX) < 45) return;

    if (diffX < 0) {
      goTo(currentIndex + 1);
    } else {
      goTo(currentIndex - 1);
    }
  });

  on(galleryStage, "mouseleave", function () {
    mouseDown = false;
  });
}

  /* ---------- FAQ accordion ---------- */
  function initAccordion() {
    $$(".acc-head").forEach(function (h) {
      on(h, "click", function () { h.closest(".acc-item").classList.toggle("open"); });
    });
  }

  /* ---------- Product mobile tabs ---------- */
  function initTabs() {
    var tabs = $$(".ptab");
    if (!tabs.length) return;
    tabs.forEach(function (t) {
      on(t, "click", function () {
        var idx = t.getAttribute("data-index");
        tabs.forEach(function (x) {
          var a = x === t;
          x.classList.toggle("text-gold", a);
          x.classList.toggle("bg-gold/10", a);
          x.classList.toggle("font-medium", a);
          x.classList.toggle("text-muted-foreground", !a);
          x.setAttribute("aria-pressed", a ? "true" : "false");
        });
        $$(".ptab-panel").forEach(function (p) {
          p.classList.toggle("hidden", p.getAttribute("data-index") !== idx);
        });
      });
    });
  }

  /* ---------- Sticky buy bar ---------- */
  function initStickyBar() {
    var bar = $("#sticky-buy");
    if (!bar) return;
    var onScroll = function () { bar.classList.toggle("show", window.scrollY > 600); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Quantity stepper (product page) ---------- */
  function initQty() {
    $$(".qty-wrap").forEach(function (w) {
      var input = $(".qty-input", w), minus = $(".qty-minus", w), plus = $(".qty-plus", w);
      if (!input) return;
      function val() { return Math.max(1, parseInt(input.value, 10) || 1); }
      on(minus, "click", function () { input.value = Math.max(1, val() - 1); });
      on(plus, "click", function () { input.value = val() + 1; });
      on(input, "change", function () { input.value = val(); });
    });
  }

  /* ---------- Hero video loading spinner ---------- */
  function initHeroLoader() {
    var loader = $("#hero-loader");
    if (!loader) return;
    var done = false;
    function hide() { if (done) return; done = true; loader.classList.add("is-hidden"); }
    var iframe = $("#heroVimeo"), video = $("#hero-mobile-video");
    var isDesktop = window.matchMedia && window.matchMedia("(min-width: 768px)").matches;

    if (isDesktop && iframe) {
      // Vimeo: hide only once real playback starts (not on iframe load)
      window.addEventListener("message", function (e) {
        if (typeof e.origin === "string" && e.origin.indexOf("vimeo") === -1) return;
        var d; try { d = JSON.parse(e.data); } catch (_) { return; }
        if (!d) return;
        if (d.event === "ready" && iframe.contentWindow) {
          ["play", "playing", "bufferend"].forEach(function (ev) {
            iframe.contentWindow.postMessage(JSON.stringify({ method: "addEventListener", value: ev }), "*");
          });
        }
        if (d.event === "play" || d.event === "playing" || d.event === "bufferend") hide();
      });
    } else if (video) {
      // MP4: hide only once the video is actually advancing
      on(video, "playing", hide);
      on(video, "timeupdate", function () { if (video.currentTime > 0) hide(); });
      if (!video.paused && video.currentTime > 0) hide();
    }

    setTimeout(hide, 10000); // safety fallback so it never hangs forever
  }

  /* ---------- Buy now: set EXACT quantity (no accumulation) → checkout ---------- */
function initBuyForms() {

  function formatMoney(cents) {
    return (cents / 100).toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + " €";
  }

  function openCartDrawer() {
    var drawer = document.getElementById("easeair-cart-drawer");
    var overlay = document.getElementById("easeair-cart-overlay");

    if (drawer) {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
    }

    if (overlay) overlay.classList.add("is-open");

    document.body.classList.add("easeair-cart-open");
  }

  function closeCartDrawer() {
    var drawer = document.getElementById("easeair-cart-drawer");
    var overlay = document.getElementById("easeair-cart-overlay");

    if (drawer) {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
    }

    if (overlay) overlay.classList.remove("is-open");

    document.body.classList.remove("easeair-cart-open");
  }

 function renderCart(cart) {
  var content = document.getElementById("easeair-cart-content");
  var total = document.getElementById("easeair-cart-total");

  if (!content || !total) return;

  total.textContent = formatMoney(cart.total_price);

  if (!cart.items.length) {
    content.innerHTML = "<p>Dein Warenkorb ist leer.</p>";
    return;
  }

  content.innerHTML = cart.items.map(function(item, index) {

    var image = item.image
      ? '<img src="' + item.image + '" alt="">'
      : "";

    return (
      '<div class="easeair-cart-item">' +

        '<div>' +
          image +
        '</div>' +

        '<div>' +

          '<div class="easeair-cart-item-title">' +
            item.product_title +
          '</div>' +

          '<div class="easeair-cart-item-price">' +
            formatMoney(item.final_line_price) +
          '</div>' +

          '<div class="easeair-cart-qty">' +

            '<button type="button" class="easeair-cart-qty-btn" data-line="' + (index + 1) + '" data-qty="' + Math.max(0, item.quantity - 1) + '">−</button>' +

            '<span class="easeair-cart-qty-value">' +
              item.quantity +
            '</span>' +

            '<button type="button" class="easeair-cart-qty-btn" data-line="' + (index + 1) + '" data-qty="' + (item.quantity + 1) + '">+</button>' +

          '</div>' +

          '<div class="easeair-cart-gift">' +
            '<strong>KOSTENLOS</strong> Premium Outdoor-Schutzhülle' +
          '</div>' +

        '</div>' +

      '</div>'
    );

  }).join("");

  $$(".easeair-cart-qty-btn").forEach(function(btn) {

    on(btn, "click", function() {

      var line = parseInt(btn.getAttribute("data-line"), 10);
      var qty = parseInt(btn.getAttribute("data-qty"), 10);

      btn.disabled = true;

      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          line: line,
          quantity: qty
        })
      })
      .then(function(response) {
        if (!response.ok) throw new Error("change");
        return response.json();
      })
      .then(function(updatedCart) {
        renderCart(updatedCart);
      })
      .catch(function(error) {
        console.error("EaseAir Cart Quantity:", error);
        btn.disabled = false;
      });

    });

  });
}

  function refreshCartAndOpen() {
    return fetch("/cart.js", {
      headers: {
        "Accept": "application/json"
      }
    })
    .then(function(response) {
      if (!response.ok) throw new Error("cart");
      return response.json();
    })
    .then(function(cart) {
      renderCart(cart);
      openCartDrawer();
    });
  }

  $$(".buy-form").forEach(function(form) {

    on(form, "submit", function(e) {

      var idEl = form.querySelector("[name=id]");
      var qtyEl = form.querySelector("[name=quantity]");

      if (!idEl || !idEl.value) return;

      e.preventDefault();

      var id = idEl.value;
      var qty = qtyEl
        ? Math.max(1, parseInt(qtyEl.value, 10) || 1)
        : 1;

      var btn = form.querySelector("button[type=submit]");

      if (btn) btn.disabled = true;

fetch("/cart/clear.js", {
  method: "POST",
  headers: {
    "Accept": "application/json"
  }
})
.then(function() {
  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      items: [
        {
          id: id,
          quantity: qty
        }
      ]
    })
  });
})
      .then(function(response) {
        if (!response.ok) throw new Error("add");
        return refreshCartAndOpen();
      })
      .then(function() {
        if (btn) btn.disabled = false;
      })
      .catch(function(error) {
        console.error("EaseAir Cart:", error);
        if (btn) btn.disabled = false;
      });

    });

  });

  var closeBtn = document.getElementById("easeair-cart-close");
  var continueBtn = document.getElementById("easeair-cart-continue");
  var overlay = document.getElementById("easeair-cart-overlay");

  if (closeBtn) on(closeBtn, "click", closeCartDrawer);
  if (continueBtn) on(continueBtn, "click", closeCartDrawer);
  if (overlay) on(overlay, "click", closeCartDrawer);

}

  function init() {
    initReveal(); initCounters(); initNav(); initThemeToggle();
    initHero(); initHeroLoader(); initGallery(); initAccordion(); initTabs();
    initStickyBar(); initQty(); initBuyForms();
  }
  if (doc.readyState === "loading") on(doc, "DOMContentLoaded", init); else init();
})();
